export default {
      id: "bulle_demarches-usage",
      viewBox: "0 0 220 210",
      url: "../dist/images/" + "sprite.svg#bulle_demarches-usage",
      toString: function () {
        return this.url;
      }
    }